if (!customElements.get('blog-progress')) {
class BlogProgress extends HTMLElement {
  connectedCallback() {
    const trackId = this.dataset.trackId;
    this.track = document.getElementById(trackId);
    if (!this.track) return;

    this.bar = this.querySelector('.blog-progress__track');
    this.thumb = this.querySelector('.blog-progress__thumb');
    this.prevBtn = this.querySelector('.blog-progress__btn--prev');
    this.nextBtn = this.querySelector('.blog-progress__btn--next');

    this.syncProgress();
    this.track.addEventListener('scroll', () => this.syncProgress(), { passive: true });
    this.prevBtn.addEventListener('click', () => this.slide(-1));
    this.nextBtn.addEventListener('click', () => this.slide(1));

    this.initDrag();
    this.initBarClick();

    this.resizeObserver = new ResizeObserver(() => this.syncProgress());
    this.resizeObserver.observe(this.track);
  }

  getItems() {
    return Array.from(this.track.querySelectorAll('.slider__slide'));
  }

  syncProgress() {
    const { scrollLeft, scrollWidth, clientWidth } = this.track;
    const max = scrollWidth - clientWidth;

    if (max <= 0) {
      this.thumb.style.width = '100%';
      this.thumb.style.marginLeft = '0%';
      this.prevBtn.disabled = true;
      this.nextBtn.disabled = true;
      return;
    }

    const items = this.getItems();
    const scrollPaddingLeft = parseFloat(getComputedStyle(this.track).scrollPaddingLeft) || 0;
    const lastSnapPoint = items.length ? items[items.length - 1].offsetLeft - scrollPaddingLeft : max;

    const ratio = lastSnapPoint > 0 ? Math.min(scrollLeft / lastSnapPoint, 1) : 0;
    const thumbPct = (clientWidth / scrollWidth) * 100;
    const thumbLeftPct = ratio * (100 - thumbPct);

    this.thumb.style.width = thumbPct + '%';
    this.thumb.style.left = thumbLeftPct + '%';
    this.prevBtn.disabled = scrollLeft <= 0;
    this.nextBtn.disabled = scrollLeft >= lastSnapPoint - 1;
  }

  slide(direction) {
    const items = this.getItems();
    if (!items.length) return;
    const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
    const stride = items[0].offsetWidth + gap;
    this.track.scrollBy({ left: direction * stride, behavior: 'smooth' });
  }

  snapToNearest() {
    const items = this.getItems();
    if (!items.length) return;
    const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
    const stride = items[0].offsetWidth + gap;
    const index = Math.round(this.track.scrollLeft / stride);
    this.track.scrollTo({ left: index * stride, behavior: 'smooth' });
  }

  initDrag() {
    let dragging = false;
    let startX = 0;
    let startScrollLeft = 0;

    const onMove = (e) => {
      if (!dragging) return;
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      const dx = clientX - startX;
      const barWidth = this.bar.offsetWidth;
      const thumbWidth = this.thumb.offsetWidth;
      const maxPx = barWidth - thumbWidth;
      const scrollMax = this.track.scrollWidth - this.track.clientWidth;
      const startRatio = maxPx > 0 ? (this.thumb.offsetLeft / maxPx) : 0;
      const newRatio = Math.max(0, Math.min(1, startRatio + dx / maxPx));
      this.track.scrollLeft = newRatio * scrollMax;
    };

    const onEnd = () => {
      if (!dragging) return;
      dragging = false;
      this.snapToNearest();
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onEnd);
      document.removeEventListener('touchmove', onMove);
      document.removeEventListener('touchend', onEnd);
    };

    this.thumb.addEventListener('mousedown', (e) => {
      dragging = true;
      startX = e.clientX;
      startScrollLeft = this.track.scrollLeft;
      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup', onEnd);
      e.preventDefault();
    });

    this.thumb.addEventListener('touchstart', (e) => {
      dragging = true;
      startX = e.touches[0].clientX;
      startScrollLeft = this.track.scrollLeft;
      document.addEventListener('touchmove', onMove, { passive: true });
      document.addEventListener('touchend', onEnd);
    }, { passive: true });
  }

  initBarClick() {
    this.bar.addEventListener('click', (e) => {
      if (e.target === this.thumb) return;
      const rect = this.bar.getBoundingClientRect();
      const ratio = (e.clientX - rect.left) / this.bar.offsetWidth;
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.track.scrollTo({ left: ratio * max, behavior: 'smooth' });
    });
  }

  disconnectedCallback() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
  }
}

customElements.define('blog-progress', BlogProgress);
}
